import _each from "lodash/each";
import store from "~/js/store/store";

export default class AppModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        isHome: false,
        isPinSection: false,
        isInit: false,
        scrollto: "",
        scrollY: 0,
        scrollYPin: false,
        scrollYPrev: 0,
        scrolltoDuration: 0.8,
        scrolltotop: 0,
        scrollInNavi: 0,
        windowWidth: 0,
        windowWidthPrev: 0,
        naviOpened: false,
        deviceType: "PC",
        // PinSection TODO モジュール分解
        pinSection: {
          isScrolling: false,
          autoPlayTime: 0,
          prevIndex: 0,
          nextIndex: 0,
          to: 0,
          sectionLength: 0,
          multiImageLength: 0, // 画像複数枚表示コンポーネント トータル
          multiImageCount: 0, // 画像複数枚表示コンポーネント カウント
          multiImageTime: 0, // 画像複数枚表示コンポーネント 切り替え時間
          nextSection: null,
          footerScrolled: false // フッターが内部でスクロールをしたかの真偽
        },
        keyboard: {
          code: "",
          target: null
        },
        sticky: {
          isSticky: false
        }
      },

      getters: {
        isLoading(state) {
          return false;
        },

        isScrollDown(state) {
          return state.scrollY - state.scrollYPrev > 0;
        },

        isMenuOpen(state) {
          return state.naviOpened;
        },

        // 複数子をもっているコレクションか
        isDoubleCollection(state) {
          let sec = state.pinSection.nextSection;
          let result = 0;
          if (!sec) {
            return 0;
          }
          _each(sec.children, (elm) => {
            if (elm.classList.contains("js-multiimage")) {
              result += 1;
            }
          });
          return result;
        },

        // 最後のPin度目要素を表示しているかどうかの真偽
        isLastPin(state) {
          return state.pinSection.nextIndex >= state.pinSection.sectionLength - 1;
        },
        // 最後から2番目以降の要素かどうか
        isLast2Pin(state) {
          return state.pinSection.nextIndex >= state.pinSection.sectionLength - 2;
        }
      },

      // Mutations ----------------------------------------
      mutations: {
        home(state) {
          state.isHome = true;
          state.isPinSection = true;
        },
        updateStickyPin(state, isPin) {
          state.sticky.isSticky = isPin;
        },
        setIsPinsection(state) {
          state.scrollYPin = true;
          state.isPinSection = true;
        },
        scrollto(state, to) {
          state.scrollto = to;
        },
        scrollY(state, payload) {
          state.scrollYPrev = state.scrollY;
          state.scrollY = payload.y;
          // state.scrollYPin = payload.isPin || false;
        },
        scrolltoTop(state, duration) {
          state.scrolltoDuration = duration;
          state.scrolltotop += 1;
        },
        toggleNavi(state) {
          state.naviOpened = !state.naviOpened;
        },
        closeNavi(state) {
          state.naviOpened = false;
        },
        updateDeviceType(state, type) {
          state.deviceType = type;
        },

        beforeScroll(state, payload) {
          state.pinSection.isScrolling = true;
          state.pinSection.prevIndex = payload.prev;
          state.pinSection.nextIndex = payload.next;
          state.pinSection.nextSection = payload.section;
        },
        afterScroll(state, payload) {
          state.pinSection.isScrolling = false;
        },
        init(state) {
          state.isInit = true;
        },
        changePinScroll(state, index) {
          state.pinSection.to = index;
          state.pinSection.footerScrolled = false;
        },
        footerScroll(state) {
          state.pinSection.footerScrolled = true;
        },
        multiImage(state, payload) {
          state.pinSection.multiImageLength = payload.length;
          state.pinSection.multiImageCount = payload.count;
        },
        multiImageTime(state, time) {
          state.pinSection.multiImageTime = time;
        },
        pinSectionAutoplayTime(state, time) {
          state.pinSection.autoPlayTime = time;
        },
        setupPinSection(state, payload) {
          state.pinSection.sectionLength = payload.length;
        },
        scrollInNavi(state, y) {
          state.scrollInNavi = y;
        },

        windowResized(state, payload) {
          state.windowWidthPrev = state.windowWidth;
          state.windowWidth = payload.width;
        },
        deviceSizeChanged(state) {},

        keydown(state, target) {},
        keyup(state, target) {
          state.keyboard.target = target;
        },
        enterKeyUp(state) {},
        tabKeyDown(state) {},
        tabKeyUp(state) {},
        arrowDownKeyUp(state) {},
        arrowUpKeyUp(state) {},
        shoppingBugUpdate(state) {}
      },
      // Actions ----------------------------------------
      actions: {
        home({ commit, state }, payload) {
          commit("home");
        },
        updateStickyPin({ commit, state }, payload) {
          commit("updateStickyPin", payload.isPin);
        },
        setIsPinsection({ commit, state }, payload) {
          commit("setIsPinsection");
        },
        scrollto({ commit, state }, payload) {
          commit("scrollto", payload.to);
        },
        scrollY({ commit, state }, payload) {
          commit("scrollY", payload);
        },
        scrolltoTop({ commit, state }, payload) {
          commit("scrolltoTop", payload.duration || 0.8);
        },
        toggleNavi({ commit, state }, payload) {
          commit("toggleNavi");
        },
        closeNavi({ commit, state }, payload) {
          commit("closeNavi");
        },
        updateDeviceType({ commit, state }, payload) {
          if (payload.width <= store.state.constant.spWidth) {
            commit("updateDeviceType", "SP");
          } else {
            commit("updateDeviceType", "PC");
          }
        },

        beforeScroll({ commit, state }, payload) {
          commit("beforeScroll", payload);
        },
        afterScroll({ commit, state }, payload) {
          commit("afterScroll", payload);
          commit("scrollY", payload);
        },
        init({ commit, state }) {
          commit("init");
        },
        changePinScroll({ commit, state }, payload) {
          commit("changePinScroll", payload.index);
        },
        footerScroll({ commit, state }, payload) {
          commit("footerScroll");
        },
        multiImage({ commit, state }, payload) {
          commit("multiImage", payload);
        },
        multiImageTime({ commit, state }, payload) {
          commit("multiImageTime", payload.time);
        },
        pinSectionAutoplayTime({ commit, state }, payload) {
          commit("pinSectionAutoplayTime", payload.time);
        },
        setupPinSection({ commit, state }, payload) {
          commit("setupPinSection", payload);
        },
        scrollInNavi({ commit, state }, payload) {
          commit("scrollInNavi", payload.y);
        },

        windowResized({ commit, state }, payload) {
          commit("windowResized", payload);
          const bp = state.isPinSection ? store.state.constant.tabletWidth : store.state.constant.spWidth;
          if (payload.width <= bp) {
            if (state.deviceType !== "SP") {
              commit("deviceSizeChanged");
            }
            commit("updateDeviceType", "SP");
          } else {
            if (state.deviceType !== "PC") {
              commit("deviceSizeChanged");
            }
            commit("updateDeviceType", "PC");
          }
        },

        keydown({ commit, state }, payload) {
          commit("keydown", payload.target);
          if (payload.code === "Tab") {
            commit("tabKeyDown");
          }
        },

        keyup({ commit, state }, payload) {
          commit("keyup", payload.target);
          if (payload.code === "Enter") {
            commit("enterKeyUp");
          } else if (payload.code === "Tab") {
            commit("tabKeyUp");
          } else if (payload.code === "ArrowDown") {
            commit("arrowDownKeyUp");
          } else if (payload.code === "ArrowUp") {
            commit("arrowUpKeyUp");
          }
        },
        shoppingBugUpdate({ commit, state }, payload){
          commit("shoppingBugUpdate");
        }

      }
    };
  }

  getModule() {
    return this.module;
  }
}
